export default __webpack_public_path__ + "static/media/gallery-2.31c8607f.jpg";